/**
 * 滚动进入视口时添加 .reveal--visible（配合 src/apps/official/styles/motion.css）
 */
function bindReveal(el) {
  if (!el.classList.contains("reveal")) {
    el.classList.add("reveal");
  }

  if (typeof IntersectionObserver === "undefined") {
    el.classList.add("reveal--visible");
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("reveal--visible");
          io.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: "0px 0px -6% 0px",
      threshold: 0.06
    }
  );

  io.observe(el);
  el.__revealIo = io;
}

export default {
  inserted(el) {
    bindReveal(el);
  },
  unbind(el) {
    if (el.__revealIo) {
      el.__revealIo.disconnect();
      delete el.__revealIo;
    }
  }
};
